import React from 'react'

export const NoAcceso = () => {
    return(
        <div className='container mt-5' style={{minHeight:'100vh'}}>
            <div className="alert alert-danger text-center" role="alert">
                <h5> No Tiene Permisos Para Acceder a Este Módulo! </h5>
                Contacte al Administrador
            </div>
        </div>
    )
}
